import React from "react";
import { observer, Observer } from "mobx-react-lite";
import { registerView, View, ViewComponent } from "@frui.ts/views";
import RootViewModel from "viewModels/rootViewModel";
import PaymentValidationViewModel from "../viewModels/paymentValidation/paymentValidationViewModel";
import TradingPlacesViewModel from "../viewModels/tradingPlaces/tradingPlacesViewModel";
import OutagesWidgetViewModel from "../viewModels/outages/outagesWidgetViewModel";
import ChargeTypesViewModel from "../viewModels/chargeTypes/chargeTypesViewModel";
import MultiEshopViewModel from "viewModels/multiEshop/multiEshopViewModel";
import EshopViewModel from "viewModels/eshop/eshopViewModel";
import PriceListViewModel from "viewModels/common/priceListViewModel";
import CustomerReviewViewModel from "viewModels/customerReview/customerReviewViewModel";

const rootView: ViewComponent<RootViewModel> = observer(({ vm }) => {
  const hasMargin =
    vm.activeChild &&
    !(
      vm.activeChild instanceof PaymentValidationViewModel ||
      vm.activeChild instanceof MultiEshopViewModel ||
      vm.activeChild instanceof EshopViewModel ||
      vm.activeChild instanceof TradingPlacesViewModel ||
      vm.activeChild instanceof OutagesWidgetViewModel ||
      vm.activeChild instanceof ChargeTypesViewModel ||
      vm.activeChild instanceof PriceListViewModel ||
      vm.activeChild instanceof CustomerReviewViewModel
    );

  const view = <View vm={vm.activeChild} />;

  return (
    <>
      <Observer>
        {() => {
          if (vm.alerts.length < 1) {
            return null;
          }
          return (
            <div className={`position-sticky ${hasMargin && "mb-n5"}`} style={{ top: "8px", zIndex: 1000 }}>
              {vm.alerts.map((item, i) => (
                <View key={i} vm={item} useLifecycle />
              ))}
            </div>
          );
        }}
      </Observer>
      {hasMargin ? <div className="mt-7">{view}</div> : view}
    </>
  );
});

registerView(rootView, RootViewModel);
